import { PACKAGE_RETURN_TO_STATE_KEY, setPackageReturnTo } from "../../../custom_utilities/dashboardBannerNavigation";
import { setStoreCurrentHandbookDetails } from "../../../redux/handbook/HandbookSlice";
import saveTransactionAction from "../../../redux/handbook_payment_gateway/action";
import {
  trackWebEngageBuyNow,
  trackWebEngageProgramViewed,
} from "../../../custom_utilities/webengage/webengageService";

export const buyHandbookNow = (history, dispatch, book, options = {}) => {
  if (!book?.p_id) return;

  const { returnTo } = options;
  const mrp = book?.price;
  const payable = book?.discounted_price || book?.total_price || mrp;
  const discount =
    book?.discount ||
    (mrp != null && payable != null ? Number(mrp) - Number(payable) : 0);
  const productPayload = {
    ...book,
    product_id: book?.p_id || book?.product_id,
    p_id: book?.p_id || book?.product_id,
    product_name: book?.product_name || book?.name || book?.title,
    description:
      book?.description || book?.PackageInstallmentDetails?.description,
    discounted_price: payable,
    price: mrp,
    amount: mrp,
    discount,
  };

  trackWebEngageBuyNow(productPayload, {
    card_section: "handbook",
    product_price: payable,
    product_details: productPayload.description,
  });
  trackWebEngageProgramViewed(productPayload, {
    type: "handbook",
    offers: discount,
  });

  dispatch(saveTransactionAction.setTab("single_product"));
  dispatch(setStoreCurrentHandbookDetails(book));

  const navigationState = {
    cartProducts: [book],
    ...(returnTo ? { [PACKAGE_RETURN_TO_STATE_KEY]: returnTo } : {}),
  };

  if (returnTo) {
    setPackageReturnTo(returnTo);
  }

  if (history.location.pathname === "/handbook/cart-list") {
    history.replace({
      pathname: "/handbook/cart-list",
      search: `?productId=${book.p_id}`,
      state: navigationState,
    });
    return;
  }

  history.push({
    pathname: "/handbook/cart-list",
    search: `?productId=${book.p_id}`,
    state: navigationState,
  });
};
